import * as React from 'react';

import * as Settings from '../contexts/settings';
import * as Services from '../../lib/services';
import { createWellspringServiceClient } from '../../lib/serviceClient';

import { Entity } from './entity';

export interface LouverSizingRenderProps {
    entityKey: string;
    layoutName: string;
    sizesGridName: string;
    addPerformanceSize: (selectorEntityKey: string, sizeIds: Array<string>) => void;
}

export interface LouverSizingProps {
    application: string;
    render?: (props: LouverSizingRenderProps) => JSX.Element;
}
export function LouverSizing({ application, render }: LouverSizingProps) {
    const [ settings ] = Settings.useSettings();

    const [ serviceClient, setServiceClient ] = React.useState<Services.Louver.SizingServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.Louver.SizingServiceClient, settings.servicesUrl, 'bff.cygnus.louver.sizing'));
    }, [ settings ]);

    const [ context, setContext ] = React.useState(new Services.Louver.SizingContext());
    React.useEffect(() => {(async () => {
        await serviceClient?.init(context, new Services.Louver.SizingInitializationParams({
            application
        }));
        setContext(context.clone());
    })().catch(err => {
        console.error(err)
    })}, [ serviceClient ]);

    const addPerformanceSize: LouverSizingRenderProps['addPerformanceSize'] = (selectorEntityKey, sizeIds) => {(async () => {
        await serviceClient?.addPerformanceSizes(context, selectorEntityKey, sizeIds);
        setContext(context.clone());
    })()}

    return (
        <React.Fragment>
            {render && ((context.entityKey && context.layoutName) ? render({
                entityKey: context.entityKey,
                layoutName: context.layoutName,
                sizesGridName: context.sizesGridName,
                addPerformanceSize
            }) : <em>Creating sizing entity...</em>)}
        </React.Fragment>
    );
}

export const useLouverSizingXM = (application: string) => {
    const [ settings ] = Settings.useSettings();

    const [ serviceClient, setServiceClient ] = React.useState<Services.Louver.SizingServiceClient>();
    React.useEffect(() => {
        setServiceClient(createWellspringServiceClient(Services.Louver.SizingServiceClient, settings.servicesUrl, 'bff.cygnus.louver.sizing'));
    }, [ settings ]);

    const [ context, setContext ] = React.useState(new Services.Louver.SizingContext());
    React.useEffect(() => {(async () => {
        const initParams = Services.Louver.SizingInitializationParams.parse({
            application,
            "defaults": [
                {
                    name: 'CoatingType',
                    value: 'None'
                },
                {
                    name: 'CoatingPerformance',
                    value: 'None'
                },

                // { "name": "UnionLabel", "value": "NoPreference", "restrict": false },
                // { "name": "DamperOperation", "value": "Counterbalance", "restrict": false },
                // { "name": "FinishAccessory", "value": "No", "restrict": false },
                // { "name": "CoatingPerformance", "value": "AAMA2605", "restrict": false },
                // { "name": "CoatingPreference", "value": "NoPreference", "restrict": false },
                // { "name": "CoatingType", "value": "BakedEnamel", "restrict": false },
                { "name": "Model", "value": "ESD-403", "restrict": true },
                // { "name": "BlankOffPanelsIntFinish", "value": "Mill", "restrict": false },
                // {
                //   "name": "BlankOffPanelsMaterialThickness",
                //   "value": "0.032",
                //   "restrict": false
                // },
                // { "name": "MountingAnglesType", "value": "Clip", "restrict": false },
                // { "name": "MountingAnglesFinish", "value": "Mill", "restrict": false },
                // { "name": "ContinuousBlade", "value": "No", "restrict": false },
                // { "name": "DamperApplication", "value": "Intake", "restrict": false },
                // { "name": "DamperFinishType", "value": "None", "restrict": false },
                // {
                //   "name": "DamperBladeSealMaterialType",
                //   "value": "ThermoPlasticElastomer",
                //   "restrict": false
                // },
                // {
                //   "name": "DamperActuatorFailurePosition",
                //   "value": "Closed",
                //   "restrict": false
                // },
                // { "name": "DamperNemaEnclosure", "value": "None", "restrict": false },
                // {
                //   "name": "DamperLinkageMaterialTypeCalc",
                //   "value": "Steel",
                //   "restrict": false
                // },
                // { "name": "DamperFrameType", "value": "Channel", "restrict": false },
                // { "name": "DamperAxleMaterialType", "value": "Steel", "restrict": false },
                // {
                //   "name": "DamperAxleBearingType",
                //   "value": "Synthetic",
                //   "restrict": false
                // },
                // { "name": "RequestedSleeveLength", "value": "None", "restrict": false },
                // { "name": "HingedFrame", "value": "No", "restrict": false },
                // { "name": "RearModule", "value": "No", "restrict": false },
                // { "name": "FinishColorRear", "value": "MatchLouver", "restrict": false },
                // { "name": "LargeLouverSizing", "value": "Select", "restrict": false },
                // { "name": "LouverProductType", "value": "Stationary", "restrict": false },
                // { "name": "IncompleteByERSChange", "value": "No", "restrict": false },
                // { "name": "FlangeAccessoryOnly", "value": "No", "restrict": false },
                // { "name": "FilterThickness", "value": "1", "restrict": false },
                // { "name": "FrameMaterialType", "value": "Aluminum", "restrict": false },
                // { "name": "InvalidByNoValidSelections", "value": "No", "restrict": false },
                // { "name": "FrameType", "value": "Channel", "restrict": false },
                // { "name": "FrameThickness", "value": "0.125", "restrict": false },
                // { "name": "LouverShape", "value": "Rectangular", "restrict": false },
                // { "name": "BladeThickness", "value": "0.081", "restrict": false },
                // { "name": "ImpactQualified", "value": "None", "restrict": false },
                // { "name": "SizingMethod", "value": "Nominal", "restrict": false },
                // { "name": "LouverType", "value": "DischargeOnly", "restrict": false },
                // { "name": "SpecialtyShape", "value": "None", "restrict": false },
                // { "name": "WeldedConstruction", "value": "No", "restrict": false },
                // { "name": "FinishType", "value": "Painted", "restrict": false },
                // { "name": "FinishColor", "value": "ToBeSelected", "restrict": false },
                // { "name": "FinishWarranty", "value": "1YearStandard", "restrict": false },
                // { "name": "ProductWarranty", "value": "1YearStandard", "restrict": false },
                // { "name": "BuildingSubstrateCondition", "value": "CMU", "restrict": false },
                // { "name": "DamperAccessory", "value": "No", "restrict": false },
                // { "name": "MountingAngles", "value": "No", "restrict": false },
                // { "name": "ExtendedSill", "value": "No", "restrict": false },
                // { "name": "EndDams", "value": "No", "restrict": false },
                // { "name": "BlankOffPanels", "value": "No", "restrict": false },
                // { "name": "BlankOffPanelsExtFinish", "value": "Black", "restrict": false },
                // { "name": "InsulationThickness", "value": "None", "restrict": false },
                // { "name": "InsulationMaterial", "value": "None", "restrict": false },
                // { "name": "ShopSealed", "value": "None", "restrict": false },
                // { "name": "Filter", "value": "No", "restrict": false },
                // { "name": "FilterSupplier", "value": "Greenheck", "restrict": false },
                // { "name": "FilterType", "value": "Permanent", "restrict": false },
                // { "name": "SecurityBars", "value": "No", "restrict": false },
                // { "name": "SecurityBarDiameter", "value": "0.5", "restrict": false },
                // { "name": "SecurityBarDirection", "value": "Vertical", "restrict": false },
                // { "name": "InsectScreen", "value": "No", "restrict": false },
                // { "name": "InsectScreenLocation", "value": "Internal", "restrict": false },
                // { "name": "InsectScreenMaterial", "value": "Aluminum", "restrict": false },
                // { "name": "BirdScreen", "value": "No", "restrict": false },
                // { "name": "BirdScreenLocation", "value": "Internal", "restrict": false },
                // { "name": "BirdScreenType", "value": "FlatExpanded", "restrict": false },
                // { "name": "BirdScreenMaterial", "value": "Aluminum", "restrict": false },
                // { "name": "BirdScreenOpening", "value": "0.5", "restrict": false },
                // {
                //   "name": "BirdScreenMaterialThickness",
                //   "value": "0.041",
                //   "restrict": false
                // },
                // { "name": "BirdScreenFinish", "value": "Mill", "restrict": false },
                // { "name": "DamperModel", "value": "BR_30", "restrict": false },
                // { "name": "DamperBladeAction", "value": "Parallel", "restrict": false },
                // { "name": "DamperActuatorType", "value": "None", "restrict": false },
                // {
                //   "name": "DamperRequestedActuatorMounting",
                //   "value": "Internal",
                //   "restrict": false
                // },
                // { "name": "DamperAuxiliarySwitches", "value": "No", "restrict": false },
                // { "name": "FlangeWidth", "value": "1.5", "restrict": false },
                // { "name": "GlassPocketSize", "value": "1", "restrict": false },
                // { "name": "IsInHouseBlendable", "value": "No", "restrict": false },
                // {
                //   "name": "EntityId",
                //   "value": "{2731B290-077F-4A3B-B640-E8AC541B599D}",
                //   "restrict": false
                // },
                // { "name": "Quantity", "value": "1", "restrict": false }
              ],
            //   "sizes": [
            //     {
            //       "defaults": [
            //         {
            //           "name": "InvalidByVektorSysControlsAccessory",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         { "name": "InvalidByMinMax", "value": "No", "restrict": false },
            //         { "name": "ContinuousBlade", "value": "No", "restrict": false },
            //         { "name": "Height2", "value": "0", "restrict": false },
            //         { "name": "CustomPSF", "value": "0", "restrict": false },
            //         { "name": "InvalidByNoCoil", "value": "No", "restrict": false },
            //         { "name": "DischargeDimension", "value": "6", "restrict": false },
            //         {
            //           "name": "InvalidByMissingRoofCurb",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         { "name": "InvalidByElevation", "value": "No", "restrict": false },
            //         { "name": "InvalidByNoValidMotor", "value": "No", "restrict": false },
            //         { "name": "InvalidByNoValidSwitch", "value": "No", "restrict": false },
            //         {
            //           "name": "InvalidByNoValidIsolator",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         { "name": "InvalidByBypassDamper", "value": "No", "restrict": false },
            //         { "name": "InvalidByLeadtime", "value": "No", "restrict": false },
            //         { "name": "InvalidBySocrates", "value": "No", "restrict": false },
            //         { "name": "InvalidByLineItem", "value": "No", "restrict": false },
            //         {
            //           "name": "InvalidByMotorMountedLeadtime",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         { "name": "InvalidByPrice", "value": "Yes", "restrict": false },
            //         {
            //           "name": "InvalidByMotorStarterEXP_DELETE",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         { "name": "InvalidByMotorListPrice", "value": "No", "restrict": false },
            //         { "name": "InvalidByRequiresReview", "value": "No", "restrict": false },
            //         { "name": "InvalidBySalesBill", "value": "No", "restrict": false },
            //         { "name": "InvalidByCurbDamperTray", "value": "No", "restrict": false },
            //         {
            //           "name": "IncompleteByIncompleteLine",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         {
            //           "name": "InvalidByDesignConditions",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         { "name": "InvalidByOverallFanDims", "value": "No", "restrict": false },
            //         {
            //           "name": "InvalidByIsolationDamper",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         {
            //           "name": "InvalidByBypassDamperSize",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         {
            //           "name": "InvalidByNumberOfBAPDampers",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         {
            //           "name": "InvalidByRequiresSeismic",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         { "name": "InvalidByDamper", "value": "No", "restrict": false },
            //         {
            //           "name": "InvalidByNoValidMotorStarter",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         {
            //           "name": "InvalidByNoValidBearingSet",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         { "name": "LineIDNumber", "value": "2-1", "restrict": true },
            //         { "name": "Quantity", "value": "1", "restrict": false },
            //         { "name": "InvalidByOther", "value": "0", "restrict": false },
            //         { "name": "InvalidByVFDAccessory", "value": "No", "restrict": false },
            //         {
            //           "name": "InvalidByNoTechServicePrice",
            //           "value": "No",
            //           "restrict": false
            //         },
            //         {
            //           "name": "EntityId",
            //           "value": "{ECFC1DC2-BA61-4A93-AB17-5EC6A1824CD0}",
            //           "restrict": false
            //         }
            //       ]
            //     }
            //   ]
        })
        await serviceClient?.init(context, initParams);

        // await serviceClient?.init(context, new Services.Louver.SizingInitializationParams({
        //     application,
        //     defaults: [
        //         new Services.Configuration.EntityStateQuestion({
        //             name: 'Model',
        //             value: 'ESD-403',
        //             // restrict: true
        //         }),
        //         // new Services.Configuration.EntityStateQuestion({
        //         //     name: 'FrameType',
        //         //     value: 'Flanged',
        //         //     // restrict: true
        //         // }),
        //         // new Services.Configuration.EntityStateQuestion({
        //         //     name: 'FrameMaterialType',
        //         //     value: 'Galvanized',
        //         //     // restrict: true
        //         // }),
        //         // new Services.Configuration.EntityStateQuestion({
        //         //     name: 'FrameThickness',
        //         //     value: '18',
        //         //     // restrict: true
        //         // })
        //     ]
        // }));
        setContext(context.clone());
    })().catch(err => {
        console.error(err)
    })}, [ serviceClient ]);

    const addPerformanceSize = async (selectorEntityKey: string, sizeIds: Array<string>) => {
        await serviceClient?.addPerformanceSizes(context, selectorEntityKey, sizeIds);
        setContext(context.clone());
    }
    const applyPerformanceSize = async (sizeId: string, selectorEntityKey: string, performanceSizeId: string) => {
        await serviceClient?.applyPerformanceSize(context, sizeId, selectorEntityKey, performanceSizeId);
        setContext(context.clone());
    }

    return [ context, addPerformanceSize, applyPerformanceSize ] as const;
}